import script from "./update-works.vue?vue&type=script&setup=true&lang=js"
export * from "./update-works.vue?vue&type=script&setup=true&lang=js"

import "./update-works.vue?vue&type=style&index=0&id=4263ad84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4263ad84"]])

export default __exports__